
$( document ).ready(function() {

  $(".product_optiontab .first_options li").click(function() {
      $(".first_options li.active_tabs").removeClass("active_tabs"); 
     $(this).addClass("active_tabs"); 
  });
  $(".product_optiontab .second_options li").click(function() {
      $(".second_options li.active_tabs").removeClass("active_tabs"); 
     $(this).addClass("active_tabs"); 
  
  });

  $(".product_loopblock .add_to_cart").click(function(e) {
    
    e.preventDefault();
    document.dispatchEvent(new CustomEvent('theme:loading:start'));
    var SwymGrVarId = $(this).find('form [name="id"]').val();
    var SwymGrVarQty = $(this).find('form [name="quantity"]').val();
    var SwymGrVarSellingId = $(this).find('form [name="selling_plan"]').val();

    data = {
      "id": SwymGrVarId,
      "quantity": SwymGrVarQty,
      "selling_plan": SwymGrVarSellingId
    }
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function(response) { 
        console.log(response)
        $('a.header__action-item-link.header__cart-toggle').trigger('click');
        $('.header__cart-toggle').attr('aria-expanded', true);
        $('.mini-cart').attr('aria-hidden',false);
        //window.location.href = '/cart'; 
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));
        $.getJSON('/cart.js', function(cart) { 
			var result = cart.item_count;
			console.log(result);
            setTimeout (function() {
              $('#SwymGrCartCount').text(result);
            },100);
          
            setTimeout (function() {
              $('#SwymGrCartCount').text(result);
            },1200);
		});
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
      },
      error: function(error) { 
        //window.location.href = '/cart'; 
        console.log(error);
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
      }
    });
     return false;

    
    });



    $(document).on('click', '.itg_subscription-customized-online-wine-subscription-box .button', function() {
      $('html, body').animate({
          scrollTop: ($("#membar_ships").offset().top - 100)
      }, 100);
    });

 
  });




$(document).on('click', '.product_optiontab li', function() {
  var option1 =  $('.first_options .active_tabs').find('a').attr('value');
  var option2 = $('.second_options .active_tabs').find('a').attr('value');
  var Combination = option1 + ' ' + option2;
  $(document).find('.SwymGrProduct').each(function() {
    var VariantId = $(this).find('select.ssoo').find('option[vartitle="'+Combination+'"]').attr('value');
    var VariantPrice = $(this).find('select.ssoo').find('option[vartitle="'+Combination+'"]').attr('data-price');
    $(this).find('form [name="id"]').val(VariantId);
     $(this).find('.product_main_divblock .product_price h1').html(VariantPrice);
      console.log($(this).find('select.ssoo option[vartitle="'+Combination+'"]').attr('vartitle'));
      console.log(VariantId);
  });
});

setTimeout(function(){
  $('.itg_subscription-customized-online-wine-subscription-box .image-text-section .border_svg svg').show();
}, 1000);



/* BWO mobile product sticky cart */
;(function () {
  'use strict';

  var stickyCartSelector = '[data-mobile-sticky-cart]';

  function normalizeQuantity(value) {
    var quantity = parseInt(value, 10);
    return isNaN(quantity) || quantity < 1 ? 1 : Math.min(quantity, 60);
  }

  function initializeStickyCart(stickyCart) {
    if (stickyCart.getAttribute('data-mobile-sticky-cart-initialized') === 'true') {
      return;
    }

    var productFormId = stickyCart.getAttribute('data-product-form-id');
    var productForm = document.getElementById(productFormId);
    var productSection = stickyCart.closest('[data-section-type="product"]');
    if (!productForm || !productSection) {
      return;
    }

    var originalQuantity = productForm.querySelector('[name="quantity"]');
    var originalAddButton = productForm.querySelector('.product-form__add-button');
    var stickyQuantity = stickyCart.querySelector('[data-mobile-quantity]');
    var stickyAddButton = stickyCart.querySelector('[data-mobile-add-to-cart]');
    if (!originalQuantity || !originalAddButton || !stickyQuantity || !stickyAddButton) {
      return;
    }

    var stickyStatus = document.createElement('p');
    stickyStatus.className = 'mobile-sticky-cart__status';
    stickyStatus.setAttribute('role', 'alert');
    stickyStatus.hidden = true;
    stickyCart.insertBefore(stickyStatus, stickyCart.firstChild);

    function updateBottomSpacing() {
      var height = stickyCart.getBoundingClientRect().height;
      if (height > 0) {
        document.body.style.setProperty('--bwo-sticky-cart-height', Math.ceil(height + 10) + 'px');
      } else {
        document.body.style.removeProperty('--bwo-sticky-cart-height');
      }
    }

    function clearStatus() {
      stickyStatus.hidden = true;
      stickyStatus.textContent = '';
      updateBottomSpacing();
    }

    function syncQuantityFromOriginal() {
      stickyQuantity.value = String(normalizeQuantity(originalQuantity.value));
    }

    function setQuantity(value) {
      var quantity = String(normalizeQuantity(value));
      originalQuantity.value = quantity;
      stickyQuantity.value = quantity;
      originalQuantity.dispatchEvent(new Event('input', { bubbles: true }));
      originalQuantity.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function syncAddButton() {
      var isBusy = originalAddButton.getAttribute('aria-busy') === 'true';
      var isDisabled = originalAddButton.disabled || isBusy;
      var buttonText = originalAddButton.textContent.trim();
      if (buttonText) {
        stickyAddButton.textContent = buttonText;
      }
      stickyAddButton.disabled = isDisabled;
      stickyAddButton.classList.toggle('button--disabled', isDisabled);
      stickyAddButton.classList.toggle('button--primary', !isDisabled);
      if (isBusy) {
        stickyAddButton.setAttribute('aria-busy', 'true');
      } else {
        stickyAddButton.removeAttribute('aria-busy');
      }
    }

    stickyQuantity.addEventListener('change', function () {
      setQuantity(stickyQuantity.value);
    });
    stickyAddButton.addEventListener('click', function () {
      if (originalAddButton.disabled || originalAddButton.getAttribute('aria-busy') === 'true') {
        return;
      }
      setQuantity(stickyQuantity.value);
      originalAddButton.click();
      syncAddButton();
    });
    originalQuantity.addEventListener('input', syncQuantityFromOriginal);
    originalQuantity.addEventListener('change', syncQuantityFromOriginal);

    productSection.addEventListener('variant:changed', syncAddButton);
    productSection.addEventListener('bwo:cart:request-start', function (event) {
      if (event.detail.formId === productFormId) {
        clearStatus();
        syncAddButton();
      }
    });
    productSection.addEventListener('bwo:cart:error', function (event) {
      if (event.detail.formId === productFormId) {
        stickyStatus.textContent = event.detail.message;
        stickyStatus.hidden = false;
        updateBottomSpacing();
      }
    });
    productSection.addEventListener('bwo:cart:request-end', function (event) {
      if (event.detail.formId === productFormId) {
        syncAddButton();
      }
    });

    var addButtonObserver = new MutationObserver(syncAddButton);
    addButtonObserver.observe(originalAddButton, {
      attributes: true,
      childList: true,
      subtree: true
    });

    if (window.ResizeObserver) {
      var sizeObserver = new ResizeObserver(updateBottomSpacing);
      sizeObserver.observe(stickyCart);
    }
    window.addEventListener('resize', updateBottomSpacing);

    syncQuantityFromOriginal();
    syncAddButton();
    stickyCart.setAttribute('data-mobile-sticky-cart-initialized', 'true');
    stickyCart.classList.add('mobile-sticky-cart--ready');
    productSection.classList.add('bwo-has-mobile-sticky-cart');
    document.body.classList.add('bwo-mobile-sticky-cart-active');
    updateBottomSpacing();
  }

  function initializeAllStickyCarts(container) {
    var scope = container || document;
    if (scope.matches && scope.matches(stickyCartSelector)) {
      initializeStickyCart(scope);
    }
    if (scope.querySelectorAll) {
      scope.querySelectorAll(stickyCartSelector).forEach(initializeStickyCart);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeAllStickyCarts(document);
    });
  } else {
    initializeAllStickyCarts(document);
  }
  document.addEventListener('shopify:section:load', function (event) {
    initializeAllStickyCarts(event.target);
  });
})();
